"use client";

import { fieldClass } from "@repo/ui/components/ui/input";
import { cn } from "@repo/ui/lib/utils";
import type React from "react";

import { onlyDigits, toFaDigits } from "../../lib/digits";

// A numeric field that accepts Persian, Arabic or Latin digits, keeps Latin
// digits in state (`value`, `onChange`) and shows them as Persian digits.
// `format` groups the digits for display (e.g. a card number in fours).
// Styled as the shared field (F123); className adds to it.
export function DigitInput({
  value,
  onChange,
  maxLength,
  format,
  className,
  ...rest
}: Omit<React.InputHTMLAttributes<HTMLInputElement>, "value" | "onChange" | "maxLength"> & {
  value: string;
  onChange: (digits: string) => void;
  maxLength: number;
  format?: (digits: string) => string;
}) {
  return (
    <input
      {...rest}
      inputMode="numeric"
      dir="ltr"
      value={toFaDigits(format ? format(value) : value)}
      onChange={(e) => onChange(onlyDigits(e.target.value, maxLength))}
      className={cn(fieldClass, "text-left tabular-nums", className)}
    />
  );
}

/** "6037 9912 3456 7893" */
export const groupFours = (d: string) => d.replace(/(\d{4})(?=\d)/g, "$1 ");
/** "1369/01/25" */
export const jalaliDate = (d: string) => [d.slice(0, 4), d.slice(4, 6), d.slice(6, 8)].filter(Boolean).join("/");
